// Essential for all components
import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import {withRouter} from "react-router-dom";

import get from 'lodash-es/get';
import {connect} from "react-redux";
import {setBreadcrumb} from "../../Redux/Action/breadcrumbAction";
import Grid from "@material-ui/core/Grid";
import {Button, Checkbox, FormControlLabel} from "@material-ui/core";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import {Field, Form, Formik} from "formik";
import * as Yup from "yup";

import ErrorMessage from "../../components/100Include/ErrorMessage";
import moment from "moment";
import DatePickerField from "../../components/103FormikCustom/DatePickerField";
import {apiAuction} from "../../Api/_ApiAuction";
import * as apiIndustry from "../../Api/_ApiIndustry";
import * as apiIndustryEssentialAttribute from "../../Api/_ApiIndustryEssentialAttribute.js";
import {apiFile} from "../../Api/_ApiFiles";
import {addMessage} from "../../Redux/Action/messageAction";
import CommonUtils from '../../utils/CommonUtils';
import * as sha1 from 'js-sha1';

class AuctionUpdate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industryTypeEssentialAttributes: [],
            industryTypeEssentialAttributesMap: {},
            industryTypes: [],
            industryTypesMap: {},
            industryTypeAttributesMap: {},
            publicAuctionData: null,
            intervalHandle: null,
        };
    }

    componentDidMount() {
        this.loadIndustryTypes().then(() => {
            this.loadPublicAuctionData();
            const intervalHandle = setInterval(() => {
                this.loadPublicAuctionData();
            }, 1000);
            this.setState({
                intervalHandle: intervalHandle
            });
        });
        // const { t } = this.props;
        // const breadcrumb = [{
        //     title: t("AuctionManagement:addAuction"),
        //     link: null
        // }];
        // this.props.setBreadcrumbP({breadcrumbData: breadcrumb});
    }

    componentWillUnmount() {
        const { intervalHandle } = this.state;
        if (intervalHandle) {
            clearInterval(intervalHandle);
            this.setState({
                intervalHandle: null
            });
        }
    }

    render() {
        const { publicAuctionData } = this.state;
        if (publicAuctionData) {
            return <div>
                <div className="main__container">
                    {publicAuctionData.cover_image && <p><img style={{maxWidth: '80%'}} src={publicAuctionData.cover_image} /></p>}
                    <h1>{publicAuctionData.title_en}</h1><br/>
                    <h1>{publicAuctionData.title_zh}</h1>
                    <p>Unit Price: {publicAuctionData.unit_price}</p>
                    <p>Lot ID: {publicAuctionData.lot_id}</p>
                    <p>Quantity: {publicAuctionData.quantity}</p>
                    <p>Dimension: {publicAuctionData.dimension}</p>
                    <p>Description: {publicAuctionData.description}</p>
                    {publicAuctionData.detail_image_1 && <p><img style={{maxWidth: '80%'}} src={publicAuctionData.detail_image_1} /></p>}
                    {publicAuctionData.detail_image_2 && <p><img style={{maxWidth: '80%'}} src={publicAuctionData.detail_image_2} /></p>}
                    {publicAuctionData.detail_image_3 && <p><img style={{maxWidth: '80%'}} src={publicAuctionData.detail_image_3} /></p>}
                </div>
            </div>;
        } else {
            return <div>
                <div className="main__container flex-center-item">
                    <div>No opening offline auction</div>
                </div>
            </div>;
        }
    }

    loadIndustryTypes() {
        return Promise.all([
            apiIndustryEssentialAttribute.getList({
                $expand: 'industry_type_attributes',
                $orderby: 'sequence'
            }).then(obj => {
                if (obj && obj.status === 200) {
                    if (obj.data) {
                        const industryTypeEssentialAttributes = obj.data;
                        const industryTypeEssentialAttributesMap = {};
                        industryTypeEssentialAttributes.forEach(industryTypeEssentialAttribute => {
                            const id = industryTypeEssentialAttribute.industry_type_essential_attribute_id;
                            industryTypeEssentialAttributesMap[id] = industryTypeEssentialAttribute;
                        });
                        this.setState({
                            industryTypeEssentialAttributes: industryTypeEssentialAttributes,
                            industryTypeEssentialAttributesMap: industryTypeEssentialAttributesMap
                        });
                    }
                } else {
                    console.log(obj.error);
                }
            }),
            apiIndustry.getList({
                $expand: 'industry_type_attributes',
                $orderby: 'sequence'
            }).then(obj => {
                if (obj && obj.status === 200) {
                    if (obj.data) {
                        const industryTypes = obj.data;
                        const industryTypesMap = {};
                        const industryTypeAttributesMap = {};
                        industryTypes.forEach(industryType => {
                            const id = industryType.industry_type_id;
                            industryTypesMap[id] = industryType;
                            industryType.industry_type_attributes.forEach(industryTypeAttribute => {
                                const attrId = industryTypeAttribute.industry_type_attribute_id;
                                industryTypeAttributesMap[attrId] = industryTypeAttribute;
                            });
                        })
                        this.setState({
                            industryTypes: industryTypes,
                            industryTypesMap: industryTypesMap,
                            industryTypeAttributesMap: industryTypeAttributesMap
                        });
                    }
                } else {
                    console.log(obj.error)
                }
            })
        ]);
    }

    loadPublicAuctionData() {
        const now = new Date();
        // TODO: avoid hard-code the platform id
        apiAuction.getLots('6278a11b-6f75-45d6-b044-5d3ea999c973', {
            'end_time[gte]': now.getTime(),
            $orderby: 'end_time',
            $expand: 'auction_attributes'
        }).then(res => {
            if (res && res.status === 200) {
                if (res.data.length > 0) {
                    const { industryTypeAttributesMap } = this.state;
                    const publicAuction = res.data[0];
                    const lot_id = publicAuction.lot_number;
                    const unit_price = publicAuction.price_per_unit;
                    const quantity = publicAuction.quantity;
                    const auctionAttributes = publicAuction.auction_attributes;
                    const auctionAttributesMap = {};
                    auctionAttributes.forEach(auctionAttribute => {
                        const industryTypeAttrId = auctionAttribute.industry_type_attribute_id;
                        auctionAttributesMap[industryTypeAttrId] = auctionAttribute;
                    });

                    // TODO: avoid hard-coded industry_type_attribute_id
                    const cover_image = get(auctionAttributesMap, ['ce777f0b-6901-4c57-99a3-0c7011c86e86', 'value']);
                    const title_en = get(auctionAttributesMap, ['ec9b7cfe-92b5-42e7-a1ba-d266c2141722', 'value']);
                    const title_zh = get(auctionAttributesMap, ['a0212dd1-3789-4626-b627-1ab6d3f057c0', 'value']);
                    const dimension = get(auctionAttributesMap, ['d6836769-f3f4-4184-be76-e7c03e159fe9', 'value']);
                    const description = get(auctionAttributesMap, ['b8980501-6e43-4446-a336-f74fe5e564b8', 'value']);
                    const detail_image_1 = get(auctionAttributesMap, ['1f43edbe-a0cd-420d-ac46-d4678981be03', 'value']);
                    const detail_image_2 = get(auctionAttributesMap, ['8cbce2da-8944-44cb-a6e6-316d44daf4bb', 'value']);
                    const detail_image_3 = get(auctionAttributesMap, ['f963b7a5-6241-415c-9086-f973a97aaf84', 'value']);

                    const publicAuctionData = {
                        lot_id,
                        unit_price,
                        quantity,

                        cover_image,
                        title_en,
                        title_zh,
                        dimension,
                        description,
                        detail_image_1,
                        detail_image_2,
                        detail_image_3
                    };
                    this.setState({
                        publicAuctionData: publicAuctionData
                    });
                }
            }
        })
    }
}
const mapStateToProps = (state) => ({
    auth: state.auth,
    breadcrumbArr: state.breadcrumb.breadcrumbArr
});
const mapDispatchToProps = dispatch => ({
    setBreadcrumbP: data => dispatch(setBreadcrumb(data)),
    addMessageP: data => dispatch(addMessage(data)),
});
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withRouter(AuctionUpdate)));
